module.exports = __webpack_public_path__ + "static/media/departure_board_white_24dp.d516ff14.svg";